import React from "react";
import PropTypes from "prop-types";

import { useTooltip } from "../../hooks/useTooltip";

export default function EstimateTdDescription({ description }) {
  const ref = useTooltip();
  const maxLen = 64;
  const truncated = description.substring(0, maxLen);
  const useEllipsis = description.length > maxLen;

  const cssTruncate = {
    maxWidth: "512px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  return (
    <td>
      <div style={cssTruncate}>
        <i
          className="material-icons cursor-pointer left"
          data-tooltip={description}
          data-position="top"
          ref={ref}
        >
          info
        </i>
        {description}
      </div>
    </td>
  );
}

EstimateTdDescription.propTypes = {
  description: PropTypes.string,
};
